
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-edit-region-color.html
riot.tag2('menu-item-edit-region-color',
  '<div class="color-icon-group"> <div class="color-picker-toggle-button-swatch floating-menu_icon" riot-style="background-color: {this.getSelectedColor()}"></div> </div> <span class="floating-menu_label">Color</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <div class="colorPicker"> <color-picker if="{colorPickerVisible}" positioning="{\'top: 0px; left: 100%\'}" colors="{colorChoices}" setcolor="{setRegionColor}" selectedcolor="{getSelectedColor()}" type="tag" todo rename this></color-picker> </div>',
  '',
  'class="floating-menu_item" onmouseenter="{openColorPicker}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _menuUi = require('lib/menu-ui');

var _regionUi = require('lib/region-ui');

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = opts.canvas;
this.colorChoices = _constants.CARD_COLORS;

this.setRegionColor = _menuUi.mui.setRegionColor.bind(this);
this.getSelectedColor = _menuUi.mui.getRegionSelectedColor.bind(this);

_menuUi.mui.registerMenuItem(this, 'editRegionColor');

this.closeColorPicker = function () {
  if (_this.colorPickerVisible) {
    _this.colorPickerVisible = false;
    _this.update();
  }
};

this.openColorPicker = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'regioncolor',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      if (!_this.colorPickerVisible) {
        _this.parent.hideSubMenus();
        _this.colorPickerVisible = true;
        _this.update();
      }
    }
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-edit-region-color')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-edit-region-color.html
// module id = 702
// module chunks = 0